var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaypad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m434.57 221h-122.967v-11.912c0-19.899-16.189-36.088-36.088-36.088h-9.968c-4.974-43.039-41.635-76.566-85.985-76.566h-38.994c-36.706 0-66.568-29.862-66.568-66.567v-19.867c0-5.523-4.477-10-10-10s-10 4.477-10 10v19.867c0 47.733 38.833 86.566 86.566 86.566h38.994c33.306 0 60.975 24.589 65.814 56.566h-8.888c-19.899 0-36.088 16.189-36.088 36.088v11.913h-122.968c-42.695 0-77.43 34.735-77.43 77.43v136.14c0 42.695 34.735 77.43 77.43 77.43h357.14c42.695 0 77.43-34.735 77.43-77.43v-136.14c0-42.695-34.735-77.43-77.43-77.43zm-214.173-11.912c0-8.871 7.217-16.088 16.088-16.088h39.028c8.871 0 16.088 7.217 16.088 16.088v11.912h-71.205v-11.912zm271.603 225.482c0 31.667-25.763 57.43-57.43 57.43h-357.14c-31.667 0-57.43-25.763-57.43-57.43v-136.14c0-31.667 25.763-57.43 57.43-57.43h357.14c31.667 0 57.43 25.763 57.43 57.43z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 419.281,
    cy: 323.572,
    rx: 28.719,
    ry: 28.719,
    transform: "matrix(.998 -.071 .071 .998 -21.883 30.537)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 304.405,
    cy: 323.572,
    rx: 28.719,
    ry: 28.719,
    transform: "matrix(.987 -.16 .16 .987 -47.9 52.938)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m181.637 340.844h-20.334v-20.334c0-14.17-11.487-25.656-25.656-25.656s-25.657 11.486-25.657 25.656v20.334h-20.334c-14.169 0-25.656 11.486-25.656 25.656s11.487 25.656 25.656 25.656h20.334v20.334c0 14.17 11.487 25.656 25.656 25.656s25.656-11.487 25.656-25.656v-20.334h20.334c14.17 0 25.656-11.487 25.656-25.656s-11.485-25.656-25.655-25.656z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m419.281 380.708h-114.876c-15.861 0-28.719 12.858-28.719 28.719 0 15.861 12.858 28.719 28.719 28.719h114.876c15.861 0 28.719-12.858 28.719-28.719 0-15.861-12.858-28.719-28.719-28.719z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaypad);
export default __webpack_public_path__ + "static/media/playpad.e990da11.svg";
export { ForwardRef as ReactComponent };